// src/components/ui/LienFiche.tsx — SCE Issues
// Valeur cliquable qui ouvre une autre fiche.
//
// ─── Pourquoi un composant et pas un <button> au cas par cas ───
//
// Une valeur qui ouvre une fiche doit se distinguer d'une valeur qui ne fait
// rien, et toujours de la même manière : sur une fiche problème, PN est
// cliquable mais OF ne l'est pas, et rien dans le texte ne le dit.
//
// Un soulignement discontinu plutôt qu'un bleu de lien : la charte réserve la
// couleur au sens (métier, criticité, statut), et un PN bleu au milieu de
// badges colorés se lirait comme une catégorie de plus.

import type { ReactNode } from 'react'
import { useOuvrirFiche } from '@/components/layout/ModaleRoute'

export function LienFiche({
  vers,
  children,
  titre,
}: {
  /** Chemin de la fiche à ouvrir. Les segments variables doivent déjà être encodés. */
  vers: string
  children: ReactNode
  /** Infobulle — sert à annoncer ce que le clic va ouvrir. */
  titre?: string
}): JSX.Element {
  // Depuis une modale, `useOuvrirFiche` propage le fond EXISTANT : les fiches
  // se remplacent au-dessus de la même liste au lieu de s'empiler, et le
  // bouton Précédent reparcourt la chaîne.
  const ouvrirFiche = useOuvrirFiche()

  return (
    <button
      type="button"
      onClick={(e) => {
        // La fiche peut être rendue dans une zone elle-même cliquable
        // (rangée de liste) : sans ça, un clic ouvrirait les deux.
        e.stopPropagation()
        ouvrirFiche(vers)
      }}
      title={titre}
      style={{
        background: 'none',
        border: 'none',
        padding: 0,
        font: 'inherit',
        color: 'inherit',
        cursor: 'pointer',
        textDecoration: 'underline dashed',
        textUnderlineOffset: 3,
        textDecorationColor: 'var(--color-gray-40)',
        textDecorationThickness: 1,
      }}
    >
      {children}
    </button>
  )
}
